import { ButtonBase } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import GenericButton from "components/GenericButton/GenericButton"
import he from "date-fns/locale/he"
import moment from "moment"
import {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react"
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import styled from "styled-components"
import CalendarInputIcon from "../../components/Icons/CalendarInputIcon"
import CloseIcon from "../../components/Icons/CloseIcon"

const StyledWrapper = styled.div`
  margin-bottom: 20px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-right: 0px;
    margin-bottom: 0px;
  }
`

const StyledPickerWrapper = styled.div<{ $default: boolean; $type?: string }>`
  display: flex;
  width: 300px;
  position: relative;
  .react-datepicker__navigation-icon--next,
  .react-datepicker__navigation-icon--previous {
    transform: rotate(180deg);
    top: 0px;
  }
  .react-datepicker__navigation-icon--next {
    left: 2px;
  }
  .react-datepicker__navigation-icon--previous {
    right: 2px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
  .react-datepicker-wrapper {
    width: 300px;
    position: relative;
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: 100%;
    }
  }
  .react-datepicker__input-container {
    display: flex;
  }
  .react-datepicker__month-container {
    float: right;
  }
  .react-datepicker__month {
    padding-right: 5px;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 0px;
    }
  }
  .react-datepicker__header {
    height: 112px;
    background: #fff;
    border-bottom: 1px solid #e3e3e3;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    padding-top: 22px;
    padding-bottom: 22px;
  }
  .react-datepicker__time-container {
    padding-right: 10px;
    padding-left: 10px;
    border-left: none;
    display: flex;
    align-items: center;
    flex-direction: column;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin-right: 8px;
      width: 75px;
    }
    .react-datepicker__time {
      border-radius: 15px;
    }
  }
  .react-datepicker-popper {
    z-index: 10;
    inset: 0px 0px 0px 0px !important;
    transform: translate(0px, 30px) !important;
  }
  .react-datepicker {
    border-radius: 15px;
    box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.15);
    width: ${(p) => (p.$type === "endTime" ? "260px" : "325px")};
    border: none;
    height: 452px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: auto;
      min-width: 260px;
      padding-right: 0px;
    }
  }
  .react-datepicker__current-month {
    text-align: center;
    font-family: "NarkisBlock";
    font-size: 24px;
    font-weight: 500;
  }
  .react-datepicker__day--selected {
    background-color: #264f36;
    border-radius: 50%;
    color: #fff;
    font-weight: 100;
    outline: none;
  }
  .react-datepicker__triangle {
    display: none;
  }
  input {
    width: 300px;
    height: 50px;
    border: none;
    padding-left: 10px;
    font-size: 20px;
    font-family: Speedee, NarkisBlock;
    padding-right: 45px;
    color: #000;
    font-size: 20px;
    ${(p) => !p.$default && "direction: ltr"};
    text-align: right;
    ${(p) => p.theme.breakpoints.down("sm")} {
      font-size: 16px;
      width: 100%;
    }
    border-radius: 8px;
    border: 1px solid #e5e5e5;

    &:hover {
      border: 1px solid var(--Grey, #757575);
    }

    &:focus-within {
      border: 1px solid var(--Yellow, #ffbc0d);
      outline: none;
    }
  }
  .react-datepicker__day-name,
  .react-datepicker-time__header {
    font-size: 20px;
    font-family: NarkisBlock;
  }
  .react-datepicker__day-names {
    margin-top: 12px;
  }
  .react-datepicker__time-list-item {
    font-size: 20px;
    font-family: "NarkisBlock-Thin";
    color: #757575;
  }
  .react-datepicker__day {
    font-size: 20px;
    font-family: "NarkisBlock-Thin";
    ${(p) => p.theme.breakpoints.up("md")} {
    }
  }
  .react-datepicker__day-name {
    ${(p) => p.theme.breakpoints.up("md")} {
    }
  }
  svg {
    position: absolute;
    right: 10px;
    top: 12px;
    cursor: pointer;
  }
  ul {
    height: 245px !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .react-datepicker__header--time {
    display: flex;
    align-items: end;
    justify-content: center;
    padding: 0px;
    padding-bottom: 10px;
    ${(p) => p.theme.breakpoints.up("md")} {
      width: 85px;
    }
  }
  .react-datepicker__navigation--next {
    background-color: #f7f7f7;
    border-radius: 50%;
    right: ${(p) => (p.$type === "endTime" ? "225px" : "275px")};
    top: 22px;
    width: 31px;
    height: 31px;
    ${(p) => p.theme.breakpoints.up("md")} {
      right: ${(p) => (p.$type === "endTime" ? "225px" : "265px")};
    }
    span {
      &::before {
        left: -3px;
        border-color: #000;
        border-width: 1px 1px 0 0;
        top: 8px;
        height: 7px;
        width: 7px;
      }
    }
  }
  .react-datepicker__navigation--previous {
    background-color: #f7f7f7;
    border-radius: 50%;
    left: ${(p) => (p.$type === "endTime" ? "40px" : "70px")};
    top: 22px;
    width: 31px;
    height: 31px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      left: ${(p) => (p.$type === "endTime" ? "40px" : "65px")};
    }
    span {
      &::before {
        right: -3px;
        border-color: #000;
        border-width: 1px 1px 0 0;
        top: 8px;
        height: 7px;
        width: 7px;
      }
    }
  }
  .react-datepicker__time-list-item--selected {
    background-color: transparent !important;
    color: #264f36 !important;
    border: none;
    outline: none;
  }
  .react-datepicker__time-list-item--disabled {
    border: none;
    outline: none;
  }
  .react-datepicker__week {
    padding-top: 5px;
  }
  .react-datepicker__day--keyboard-selected {
    background: none;
    color: #000;
  }
  .react-datepicker__day--today {
    font-weight: normal;
    background-color: #f7f7f7;
    border-radius: 50%;
    color: #000000;
  }

  .react-datepicker__day--selected.react-datepicker__day--today {
    background-color: #264f36;
    color: #fff;
  }
`
const StyledSvgWrapper = styled.div<{ $type?: string }>`
  background-color: #f7f7f7;
  border-radius: 50%;
  position: absolute;
  top: 22px;
  right: 15px;
  z-index: 10;
  width: 31px;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    position: relative;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    right: ${(p) =>
      p.$type === "endTime" ? "15px" : " calc((100% - 310px) / 2);"};
  }
`
const StyledButtonWrapper = styled.div<{ $type?: string }>`
  height: 50px;
  position: absolute;
  z-index: 10;
  top: 380px;
  padding-right: 13px;
  padding-left: 13px;
  width: 100%;
  ${(p) => p.theme.breakpoints.down("sm")} {
    // Not sure why there are here
    // padding-right: ${(p) => (p.$type === "endTime" ? "15px" : "0px")};
    // padding-left: ${(p) => (p.$type === "endTime" ? "15px" : "0px")};
    padding: 0 15px;
  }
`

const CalendarButtons = styled.div<{ $type?: string }>`
  width: 230px;
  height: 30px;
  position: absolute;
  top: 340px;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  padding-left: 13px;
  padding-right: 13px;
  font-size: 20px;
  font-family: "NarkisBlock-Thin";
  ${(p) => p.theme.breakpoints.down("sm")} {
    right: ${(p) =>
      p.$type === "endTime" ? "0px" : "calc((100% - 320px) / 2)"};
    width: 240px;
    padding-left: 15px;
    padding-right: 15px;
  }
`
const StyledClearButton = styled.div`
  color: #264f36;
  cursor: pointer;
`

const StyledTodayButton = styled(ButtonBase)`
  color: #264f36;
  cursor: pointer;
  font-size: 20px;
  font-family: "NarkisBlock-Thin";
`

const StyledCalendarInput = styled.div<{ $disabled?: boolean }>`
  z-index: 1;
  pointer-events: ${(p) => (p.$disabled ? "none" : "auto")};
`

type CalendarProps = {
  date: Date | any
  setDate: Dispatch<SetStateAction<Date | string>>
  type?: string
  minDate?: Date
  filterDate?: any
  disabled?: boolean
  handleTimeChange?: any
  setEndTime?: Dispatch<SetStateAction<Date | string>>
}

const Calendar = ({
  date,
  setDate,
  type,
  minDate = new Date(),
  filterDate,
  disabled = false,
  handleTimeChange = () => {},
  setEndTime = () => {},
}: CalendarProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const defaultData = "בחרו תאריך"
  const [minTime, setMinTime] = useState(null)
  const [maxTime, setMaxTime] = useState(null)
  const isToday = useMemo(
    () => moment().format("L") === moment(date).format("L"),
    [date]
  )
  const isDesktop = useIsDesktop()

  const ref = useRef(null)

  setDefaultLocale("he_IL")
  registerLocale("he_IL", he)

  useEffect(() => {
    if (date)
      if (isToday) {
        setMinMaxDate()
      }
  }, [date])

  const setMinMaxDate = () => {
    setMinTime(new Date())
    const date = new Date()
    date.setHours(23)
    date.setMinutes(45)
    setMaxTime(date)
  }

  const onChange = (date) => {
    if (new Date(date) >= new Date()) {
      handleTimeChange()
      setDate(date)
    }
  }

  const checkCurrentDay = (date) => {
    if (
      moment().format("L") === moment(date).format("L") &&
      date < new Date()
    ) {
      setTodayDate()
    }
  }

  const setTodayDate = () => {
    const date = new Date()
    const coeff = 15 - (date.getMinutes() % 15)
    const rounded = moment().add(coeff, "minutes")
    date.setHours(rounded.hours())
    date.setMinutes(rounded.minutes())
    setDate(date)
    if (type === "startTime") setEndTime(null)
  }

  const handleCalendarClose = () => {
    setIsOpen(false)
  }
  const handleCalendarOpen = () => {
    setIsOpen(true)
    setMinTime(new Date())
    setMinMaxDate()
  }

  const twoWeeksFromNow = new Date()
  twoWeeksFromNow.setDate(twoWeeksFromNow.getDate() + 14)

  const isButtonDisabled = () => {
    const currentDate = new Date()
    const thresholdHour = 23
    const thresholdMinute = 45
    if (
      currentDate.getHours() === thresholdHour &&
      currentDate.getMinutes() > thresholdMinute
    )
      return true
    return false
  }

  const disableKeyboard = (e: any) => {
    if (!isDesktop) e.target.readOnly = true
  }

  return (
    <StyledWrapper>
      <StyledPickerWrapper $default={date} $type={type}>
        <StyledCalendarInput $disabled={disabled}>
          <CalendarInputIcon onClick={handleCalendarOpen} />
        </StyledCalendarInput>
        <DatePicker
          locale="he_IL"
          className="form-control"
          selected={date ? date : ""}
          onChange={onChange}
          value={date ? date : defaultData}
          name="selectDate"
          showTimeSelect={type !== "endTime"}
          timeIntervals={15}
          timeFormat="HH:mm"
          timeCaption="שעה"
          dateFormat={type === "endTime" ? "dd/MM/yy" : "dd/MM/yy, HH:mm"}
          maxDate={type === "schedule" ? twoWeeksFromNow : null}
          minDate={minDate}
          minTime={(isToday || !date) && minTime}
          maxTime={(isToday || !date) && maxTime}
          ref={ref}
          openToDate={date}
          onCalendarClose={handleCalendarClose}
          onCalendarOpen={handleCalendarOpen}
          open={isOpen}
          onSelect={checkCurrentDay}
          onKeyDown={(e) => {
            !isDesktop && e.preventDefault()
          }}
          onInputClick={() => setIsOpen(true)}
          filterDate={filterDate}
          disabled={disabled}
          shouldCloseOnSelect={false}
          readOnly={isDesktop ? false : true}
          onFocus={(e) => disableKeyboard(e)}
        >
          <StyledSvgWrapper onClick={handleCalendarClose} $type={type}>
            {" "}
            <CloseIcon />
          </StyledSvgWrapper>
          <StyledButtonWrapper $type={type}>
            <GenericButton
              disabled={date ? false : true}
              onClick={() => handleCalendarClose()}
              btnType="filled"
              fullWidth={true}
            >
              בחירה
            </GenericButton>
          </StyledButtonWrapper>
          <CalendarButtons $type={type}>
            <StyledClearButton
              onClick={(event) => {
                setDate(null)
                event.preventDefault()
              }}
            >
              ניקוי
            </StyledClearButton>
            {type !== "endTime" && (
              <StyledTodayButton
                onClick={setTodayDate}
                disabled={isButtonDisabled()}
              >
                היום
              </StyledTodayButton>
            )}
          </CalendarButtons>
        </DatePicker>
      </StyledPickerWrapper>
    </StyledWrapper>
  )
}
export default Calendar
